import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { BlackHeadings, white } from 'src/theme/colors';
import ColorUtils from 'src/utils/ColorUtils';
import { SignaturePageComponent } from 'src/store/signaturePage/types';

interface IResizeBox
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  component: SignaturePageComponent;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    resizeBox: {
      position: 'absolute',
      height: 8,
      width: 8,
      border: '1px solid',
    },
    eSigComponentInternalUser: {
      color: BlackHeadings,
      backgroundColor: 'transparent',
    },
    eSigComponentClient: {
      color: theme.palette.primary.main,
      backgroundColor: ColorUtils.GetColorDarknessShades(
        theme.palette.primary.main,
      ).light,
    },
  }),
);

// Component to render corner resize box indicators
export const SignatureResizeBox: React.FC<IResizeBox> = ({
  style,
  component,
}) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.resizeBox} ${
        component.value
          ? classes.eSigComponentInternalUser
          : classes.eSigComponentClient
      }`}
      style={{ backgroundColor: white, ...style }}
      data-testid="resize-box"
    />
  );
};
